import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { SparklesText } from '@/components/ui/sparkles-text';
import { ThemeToggle } from '@/components';

const PrivacyPolicy: React.FC = () => {
  const location = useLocation();
  const showBackButton = location.state?.fromLanding;

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="border-b p-4">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center gap-2">
            {showBackButton && (
              <Button variant="ghost" size="sm" asChild>
                <Link to="/" className="flex items-center gap-1">
                  <ArrowLeft className="h-4 w-4" />
                  Back
                </Link>
              </Button>
            )}
          </div>

          <div className="flex-1 flex justify-center">
            <Link to="/" className="text-xl font-bold">
              <SparklesText text="VibeCraft" />
            </Link>
          </div>

          <div>
            <ThemeToggle />
          </div>
        </div>
      </header>

      <main className="container mx-auto py-8 px-4 flex-1">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Account information (email, display name) when you sign up</li>
              <li>Game progress and statistics to save your gameplay</li>
              <li>Usage data to improve the game experience</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>To provide and maintain the VibeCraft service</li>
              <li>To save your game progress and preferences</li>
              <li>To communicate important updates about the service</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Data Storage and Security</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Data is stored securely on Google Firebase</li>
              <li>We implement strong security measures to protect your information</li>
              <li>We do not sell your personal information to third parties</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Children's Privacy</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Children under 13 may use VibeCraft with parental supervision and consent</li>
              <li>
                Parents or guardians are responsible for monitoring their children's use of
                VibeCraft
              </li>
              <li>
                If you are a parent and believe we have collected information from your child
                without consent, please contact us to have this information removed
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Your Rights</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                If you would like to request deletion of your data, please do so in the Settings
                Menu under the 'Danger Zone'
              </li>
            </ul>
          </section>

          <div className="text-sm text-muted-foreground mt-12">
            <p>Last updated: {new Date().toLocaleDateString()}</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
